const mutations = {
    setTesters(state,payload) {
        state.testers = payload
    },
}

export default mutations